import React from 'react';
import * as Survey from "survey-react";
import "survey-react/survey.css";
import {surveyService, catalogService} from '../../api';
import "./Home.css"

const Home = (props) => {
    const [governmentUnits, setGovernmentUnits] = React.useState([]);
    const [settlements, setSettlements] = React.useState([]);
    const [streets, setStreets] = React.useState([]);
    const [selectedSurvey, setSelectedSurvey] = React.useState(null);
    const surveyModelRef = React.useRef(null);


    const alphabet = "abcčćdđefghijklmnoprsštuvzž";

    const alphabetically = (first, second) => {
        let a = first.value.toLowerCase();
        let b = second.value.toLowerCase();
        // Find the first position were the strings do not match
        let position = 0;
        while(a[position] === b[position]) {
            // If both are the same don't swap
            if(!a[position] && !b[position]) return 0;
            // Otherwise the shorter one goes first
            if(!a[position]) return 1;
            if(!b[position]) return -1;
            position++;
        }
        // Then sort by the characters position
        return alphabet.indexOf(a[position]) - alphabet.indexOf(b[position]);
    }

    React.useEffect(() => {
        const fetchData = async () => {
            const responses = await Promise.all([surveyService.getSurvey('krizevci-mobility'), catalogService.getGovernmentUnits(), catalogService.getSettlements(), catalogService.getStreets(), catalogService.getCitySettlements('02143')]);

            let surveyData = responses[0];
            const jls = responses[1].map(jls => ({text:jls.name, value: jls.name}));
            const settlements = responses[4].map(fs => ({value:fs.name, text:fs.name})).sort(alphabetically);

            console.log("Got settlements:", settlements)

            try {
                surveyData.data.pages[0].elements[1].choices = settlements;
                //surveyData.data.pages[0].elements[2].visibleIf = "{question3} notempty";
                surveyData.data.pages[0].elements[2].choices = [];
                surveyData.data.pages[0].elements[9].choices = settlements;
                surveyData.data.pages[0].elements[10].choices = [];

                surveyData.data.pages[2].elements[5].choices = settlements;

                /*
                surveyData.data.pages[0].elements[14].choices = jls;
                surveyData.data.pages[0].elements[17].choices = jls;
                surveyData.data.pages[0].elements[19].choices = jls;
                */
                surveyData.data.triggers = [
                    {
                        type: "runexpression",
                        expression: "{question3} notempty",
                        runExpression: "getStreetsFromSelectedGovernmentUnit({question3}, 'question4')"
                    },
                    {
                        type: "runexpression",
                        expression: "{question16} notempty",
                        runExpression: "getStreetsFromSelectedGovernmentUnit({question16}, 'question27')"
                    },
                    {
                        type: "runexpression",
                        expression: "{question37} notempty",
                        runExpression: "getStreetsFromSelectedGovernmentUnit({question37}, 'question48')"
                    },
                    /*
                    {
                        type: "runexpression",
                        expression: "{question7} notempty",
                        runExpression: "getSettlementsFromSelectedGovernmentUnit({question7}, 'question54')"
                    },
                    {
                        type: "runexpression",
                        expression: "{question11} notempty",
                        runExpression: "getSettlementsFromSelectedGovernmentUnit({question11}, 'question12')"
                    },
                    {
                        type: "runexpression",
                        expression: "{question15} notempty",
                        runExpression: "getSettlementsFromSelectedGovernmentUnit({question15}, 'question16')"
                    },
                    {
                        type: "runexpression",
                        expression: "{question18} notempty",
                        runExpression: "getSettlementsFromSelectedGovernmentUnit({question18}, 'question57')"
                    },
                    {
                        type: "runexpression",
                        expression: "{question19} notempty",
                        runExpression: "getSettlementsFromSelectedGovernmentUnit({question19}, 'question8')"
                    }*/
                ];
            }
            catch(error) {
                console.error("Problem while setting survey data:", error)
            }

            setSelectedSurvey(surveyData);
            setGovernmentUnits(responses[1]);
            setSettlements(responses[2]);
            setStreets(responses[3]);
        }

        fetchData();
        //surveyService.updateSurvey({code: 'krizevci-mobility', payload: surveyJSON})

        //surveyService.createSurvey({code: 'krizevci-mobility', payload: surveyJSON})
    }, [])


    React.useEffect(() => {
        if(selectedSurvey) {
            surveyModelRef.current = model;
        }
        
    }, selectedSurvey)

    if(!selectedSurvey) {
        return null;
    }

    var model = new Survey.Model(selectedSurvey.data);
    
    const getSettlementsFromSelectedGovernmentUnit = (params) => {
        const search = params[0];
        const target = params[1];

        const filteredSettlements = settlements.filter(s => s.governmentUnitName == search).map(fs => ({value:fs.name, text:fs.name}));
        model.getQuestionByName(target).choices = filteredSettlements;
    }

    const getStreetsFromSelectedGovernmentUnit = (params) => {
        const search = params[0];
        const target = params[1];

        const filteredStreets = streets.filter(s => s.settlementName == search).map(fs => ({value:fs.name, text:fs.name}));
        model.getQuestionByName(target).choices = filteredStreets;
    }

    const onComplete = async (survey, options) => {
        //Write survey results into database
        await surveyService.createSurveyResponse({surveyId: selectedSurvey.surveyId, payload: survey.data});
    }

    Survey.FunctionFactory.Instance.register("getSettlementsFromSelectedGovernmentUnit", getSettlementsFromSelectedGovernmentUnit);
    Survey.FunctionFactory.Instance.register("getStreetsFromSelectedGovernmentUnit", getStreetsFromSelectedGovernmentUnit);
    Survey.locale = "hr";
    return (
        <Survey.Survey model={model} locale="hr" onComplete={onComplete} />
    )
}

export default Home;